import styled, { css } from 'styled-components';
import { InputTypes } from '../Input';

export const Container = styled.div<{
  type: InputTypes;
}>`
${({ theme, type }) => css`
  display: flex;
  flex-direction: column;
  color: ${theme.colors.grey};
  height: 4rem;
  padding: 0.8rem 0.8rem;
  border: solid 1px ${theme.colors.grey};
  border-radius: 0.8rem;
  background: ${theme.colors.lightGrey};

  ${type === 'secondary' && css`
    border: 0;
    padding: 1.2rem 0.8rem;
  `}

  > input {
    color: ${theme.colors.grey};
    height: 100%;
    width: 100%;
    border: 0;
    background: ${theme.colors.lightGrey};
    font-size: ${theme.fontSizes.default};
  }

  ${type === 'quaternary' && css`
    border: 0;
    border-bottom: solid 1px ${theme.colors.grey};
    padding: 0;
    background: transparent;

    > input {
      background: transparent;
    }
  `}
`}
`;
